import store from "@/store";

// eslint-disable-next-line no-unused-vars
export default function setToOrgLevel({ next, router, to }) {
    store.commit('admin/setCurrentSubgroup', null);
}
